import React from "react";

import { Icon } from "components";

export const StatusLabel = ({ iconName, color, text }) => (
  <div className={`status-label ${color || ""}`}>
    <Icon iconName={iconName} className="icon inline" />
    {text}
  </div>
);
